import { observable } from '@legendapp/state';

export type RatAnimationType = 'bad' | 'idle' | 'win';

type RatAnimationState = {
  animationType: RatAnimationType;

  setAnimationType: (animationType: RatAnimationType) => void;
  triggerAnimation: (
    animationType: RatAnimationType,
    duration?: number
  ) => void;
  cleanup: () => void;
};

let animationTimeout: ReturnType<typeof setTimeout> | undefined;

export const ratAnimationState$ = observable<RatAnimationState>({
  animationType: 'idle',

  setAnimationType: (animationType: RatAnimationType) => {
    if (animationTimeout) {
      clearTimeout(animationTimeout);
    }
    ratAnimationState$.animationType.set(animationType);
  },
  triggerAnimation: (animationType: RatAnimationType, duration = 1500) => {
    if (animationTimeout) {
      clearTimeout(animationTimeout);
    }
    ratAnimationState$.animationType.set(animationType);

    animationTimeout = setTimeout(() => {
      ratAnimationState$.animationType.set('idle');
    }, duration);
  },
  cleanup: () => {
    if (animationTimeout) {
      clearTimeout(animationTimeout);
      animationTimeout = undefined;
    }
  },
});
